import { Component, OnInit } from '@angular/core';
import { IFeaturedContentModel } from '@models';

@Component({
  selector: 'app-featured-display',
  templateUrl: './featured-display.component.html',
  styleUrls: ['./featured-display.component.scss']
})
export class FeaturedDisplayComponent implements OnInit {

  public features: IFeaturedContentModel[] = [
    {
      title: 'Getting Started with RxJS',
      subtitle: 'How to think in async',
      image: 'https://cms.arcurve.com/public/blog-images/_ogImage/258/Blog-Hero-Image-RxJS-and-Incomplete-Streams.jpg'
    },
    {
      title: 'I don\'t know... yet',
      subtitle: 'Propel your career with curiosity',
      image: 'squid.png'
    },
    {
      title: 'Dev Log #1',
      subtitle: 'Who wrote this crap?',
      image: 'https://adamlevin.com/wp-content/uploads/2016/08/ThinkstockPhotos-504008174.jpg'
    },
    {
      title: 'I don\'t know... yet',
      subtitle: 'Propel your career with curiosity',
      image: 'https://www.thelawofattraction.com/wp-content/uploads/101-ways-achieve-success-featured.jpg'
    },
  ]
  constructor() { }

  ngOnInit(): void {
  }

}

